import React from 'react';
import styled from 'styled-components';

export function formatInlineText(text) {
  if (!text) return text;
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    return part;
  });
}

export function formatMessageContent(content) {
  if (!content) return null;
  const lines = content.split('\n');
  const elements = [];
  let listItems = [];

  const flushList = () => {
    if (listItems.length > 0) {
      elements.push(<BulletList key={`list-${elements.length}`}>{listItems}</BulletList>);
      listItems = [];
    }
  };

  lines.forEach((line, i) => {
    const trimmed = line.trim();
    if (!trimmed) {
      flushList();
      return;
    }

    if (/^#{1,3}\s+/.test(trimmed)) {
      flushList();
      const text = trimmed.replace(/^#{1,3}\s+/, '');
      elements.push(<Heading key={i}>{formatInlineText(text)}</Heading>);
    } else if (/^[-•*]\s+/.test(trimmed)) {
      const text = trimmed.replace(/^[-•*]\s+/, '');
      listItems.push(<li key={i}>{formatInlineText(text)}</li>);
    } else if (/^\d+\.\s+/.test(trimmed)) {
      const text = trimmed.replace(/^\d+\.\s+/, '');
      listItems.push(<li key={i}>{formatInlineText(text)}</li>);
    } else {
      flushList();
      elements.push(<span key={i}>{formatInlineText(trimmed)}</span>);
    }
  });

  flushList();
  return elements;
}

const Heading = styled.div`
  color: ${p => p.theme.colors.gray800};
  font-size: var(--font-size-base);
  font-weight: ${p => p.theme.fontWeight.medium};
  margin-bottom: 2px;
`;

const BulletList = styled.ul`
  list-style: disc;
  margin: 0;
  padding-left: 20px;

  li {
    color: ${p => p.theme.colors.gray800};
    font-size: var(--font-size-base);
    line-height: 1.6;
  }
`;
